import React from 'react';
import { Icon } from '@iconify/react';

const StatCard = ({
  title,
  value,
  icon,
  iconBg = 'var(--hs-primary-50)',
  iconColor = 'var(--hs-primary-600)',
  trend = null,
  trendType = 'positive', // 'positive' | 'negative' | 'neutral'
  helperText = null,
  badge = null,
  onClick = null,
  className = ''
}) => {
  return (
    <div 
      className={`hs-stat-card-modern h-100 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
        <div className="flex-grow-1">
          <div className="hs-stat-label">{title}</div>
          <div className="hs-stat-value">{value}</div>
        </div>
        {icon && (
          <div 
            className="hs-stat-icon-wrapper"
            style={{ backgroundColor: iconBg, color: iconColor }}
          >
            <Icon icon={icon} />
          </div>
        )}
      </div>

      {(trend || helperText || badge) && (
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 pt-2 border-top" style={{ borderColor: 'var(--hs-border)' }}>
          {trend && (
            <span className={`text-xs fw-semibold d-inline-flex align-items-center gap-1 ${
              trendType === 'positive' ? 'text-success' : trendType === 'negative' ? 'text-danger' : 'text-secondary'
            }`}>
              <Icon 
                icon={
                  trendType === 'positive' 
                    ? 'solar:arrow-right-up-bold' 
                    : trendType === 'negative' 
                    ? 'solar:arrow-right-down-bold' 
                    : 'solar:minus-bold'
                } 
                className="text-xs" 
              />
              {trend}
            </span>
          )}
          {helperText && (
            <span className="text-xs" style={{ color: 'var(--hs-text-muted)' }}>
              {helperText}
            </span>
          )}
          {badge && badge}
        </div>
      )}
    </div>
  );
};

export default StatCard;
